module.exports = __webpack_public_path__ + "static/img/so2_1.acab3b7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/solution/pic/so2_1.jpg
// module id = ydwm
// module chunks = 11